var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sidebar',{attrs:{"isAdminView":true}}),_c('section',{staticClass:"main_container"},[_c('div',{staticClass:"main_container_block"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }